module.exports = __webpack_public_path__ + "static/material-rose-gold.27e4f18e.svg";